import api from './api';

const v2VaultSourceSettingsService = {
  getSettingsBySourceId: async (v2_vault_source_id) => {
    const response = await api.get(`/v2-vault-source-settings?v2_vault_source_id=${v2_vault_source_id}`);
    return response.data;
  },

  createSetting: async (data) => {
    const response = await api.post('/v2-vault-source-settings', data);
    return response.data;
  },

  updateSetting: async (id, data) => {
    const response = await api.put(`/v2-vault-source-settings/${id}`, data);
    return response.data;
  },

  deleteSetting: async (id) => {
    const response = await api.delete(`/v2-vault-source-settings/${id}`);
    return response.data;
  }
};

export default v2VaultSourceSettingsService;
